import React from 'react';
import { useTranslation } from 'react-i18next';
import { keyMap } from '@locales/lokalise/keyMap';
import cn from 'classnames';

export type TableSettingsProps = {
  changeRowsPerPage: (rowsPerPage: number) => void;
  numberOfRows: number;
  numberOfRowsList: number[];
};

const TableSettings = ({ changeRowsPerPage, numberOfRows, numberOfRowsList }: TableSettingsProps) => {
  const { i18n } = useTranslation();

  return (
    <div className="table-settings">
      <div className="table-show-items">
        <div className="table-settings__label">{i18n.t(keyMap.tableShowItems)}</div>
        <div className="table-show-items__list">
          {numberOfRowsList.map((item) => (
            <button
              key={item}
              type="button"
              className={cn('table-show-items__option', { active: item === numberOfRows })}
              onClick={() => changeRowsPerPage(item)}>
              {item}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TableSettings;
